<template>
  <div class="layout" style="position: relative;">
    <header>
      <Navbar />
    </header>
    <section>
      <AppMain />
    </section>
    <footer style="height: 128px;width: 100%;">
      <Footer />
    </footer>
  </div>
</template>
<script>
import Navbar from './Navbar'
import Footer from './Footer'
import AppMain from './AppMain'
export default {
  components: {
    Navbar,
    Footer,
    AppMain
  }
}
</script>